import '@/configs/sentry'
import '@/configs/plugins'
import '@/configs/mixin'

import Vue from 'vue'
import App from './index.vue'
import store from '../../store'
import login from '@tencent/vft-common/login'
import tenvideo from '@tencent/vft-common/tenvideo'
import env from '@tencent/vft-common/env'
import Avatar from "@tencent/vft-ui/src/Avatar"
import AccountType from "@tencent/vft-ui/src/AccountType"
import VipIcon from '@tencent/vft-ui/src/VipIcon'
import Qrcode from "@tencent/vft-ui/src/Qrcode"
import { PicGeneratorPlugin } from '@tencent/vft-image-plugins'
import Dialog from './components/Dialog'
import PayButton from './components/PayButton'
import ToYooButton from './components/ToYooButton'
import atom from '@tencent/vft-atom'
import "@tencent/huoguo-appbanner"
import { Loadmore } from 'mint-ui'
import cookie from '@tencent/vft-common/cookie'

// Vue.config.productionTip = false

Vue.use(AccountType)
Vue.use(Qrcode)
Vue.use(Avatar)
Vue.use(VipIcon)
Vue.use(PicGeneratorPlugin)
Vue.component(Dialog.name, Dialog)
Vue.component(PayButton.name, PayButton)
Vue.component(ToYooButton.name, ToYooButton)
Vue.component(Loadmore.name, Loadmore)

const console = window.console


if(env.isIphone && env.isApp && tenvideo.versionCompare(tenvideo.getAppVersion(),'6.5.0')){
  try {
    atom.invoke('predload3rdApp', {
      itunesUrl: 'https://itunes.apple.com/cn/app/id1412612805?mt=8',
      packageUrl: 'firevideo://v.qq.com/HomeTab',
      channel: 'xxx"'
    })
  } catch (e) {
    console.error(e)
  }
}


async function getPayVipAndUserInfo (store) {
  try {
    await store.dispatch('checkLogin')
    if (store.state.isLogin) {
      await Promise.all([store.dispatch('getPayVip'), store.dispatch('getUserInfo')])
    }
  } catch (err) {
    console.error(err)
  }
}

let isInit = false

async function init () {
  if (isInit) return
  isInit = true
  login.init(async () => {
    // if(login.loginType()==='wx'){
    //   let appid = cookie.get('appid')
    //   if (['wx9282d94f2b8d10fa', 'wx0bc363ec6a059e6b', 'wx028da79bd02b1e85'].some(item => item === appid)) {
    //     login.logout(() => {
    //       window.location.reload()
    //     })
    //   }
    // }
    await getPayVipAndUserInfo(store)
    new Vue({
      store,
      render: h => h(App)
    }).$mount('#app')
  })
}

init().catch(err => {
  console.error(err)
})
